import { useEffect } from 'react';

import { deleteCookie, setCookie } from 'utils/cookieHelper';
import { hostIncludesDeLocale } from 'utils/countryHelper';
import { DE_LOCALE } from 'utils/i18n';

// Local dev convenience: derive the `locale` cookie from the proxy target so
// you don't have to set it by hand when proxying to a DE environment. Mirrors
// partner-branded-signup's hook of the same name. No-op anywhere but
// localhost, so it never affects staging or production.
export const useEnvProxyForLocale = () => {
  useEffect(() => {
    if (window.location.hostname !== 'localhost') return;

    const proxyTarget = import.meta.env.VITE_PROXY_API_TARGET;
    if (hostIncludesDeLocale(proxyTarget)) {
      setCookie('locale', DE_LOCALE);
    } else {
      deleteCookie('locale');
    }
  }, []);
};
